import React, { useState } from 'react';
import './CourseSection.css';
import { Link } from 'react-router-dom';

const CourseSection = () => {
  const [activeGrade, setActiveGrade] = useState('1-3');

  const handleGradeChange = (grade) => {
    setActiveGrade(grade);
  };

  const courseData = {
    '1-3': [
      {
        id: 'polymath-kids',
        title: 'Polymath Kids',
        description: 'A fun introduction to coding for young minds aged 6-8 years.',
        learnItems: [
          'Scratch Programming',
          'Basic Math Concepts',
          'Creative Problem Solving',
          'Digital Art & Design',
          'Simple Game Creation',
          'Storytelling with Code'
        ],
        structure: {
          lessons: '40 Lessons',
          activities: '40+ Activities | 40 Quizzes'
        },
        duration: {
          option1: '10 Months (1 Lesson/Week)',
          option2: '5 Months (2 Lessons/Week)'
        }
      },
      {
        id: 'polymath-junior',
        title: 'Polymath Junior',
        description: 'Building foundational coding skills for elementary students.',
        learnItems: [
          'Block-based Programming',
          'HTML & CSS Basics',
          'Introduction to Python',
          'Digital Citizenship',
          'Basic Animation',
          'Interactive Stories'
        ],
        structure: {
          lessons: '60 Lessons',
          activities: '60+ Activities | 60 Quizzes'
        },
        duration: {
          option1: '15 Months (1 Lesson/Week)',
          option2: '8 Months (2 Lessons/Week)'
        }
      },    {
        id: 'polymath-kids',
        title: 'Polymath Kids',
        description: 'A fun introduction to coding for young minds aged 6-8 years.',
        learnItems: [
          'Scratch Programming',
          'Basic Math Concepts',
          'Creative Problem Solving',
          'Digital Art & Design',
          'Simple Game Creation',
          'Storytelling with Code'
        ],
        structure: {
          lessons: '40 Lessons',
          activities: '40+ Activities | 40 Quizzes'
        },
        duration: {
          option1: '10 Months (1 Lesson/Week)',
          option2: '5 Months (2 Lessons/Week)'
        }
      }
    ],
    '4-6': [
      {
        id: 'polymath-intermediate',
        title: 'Polymath Intermediate',
        description: 'Advanced coding concepts for middle school students.',
        learnItems: [
          'Python Programming',
          'Web Development (HTML, CSS, JavaScript)',
          'Database Basics',
          'Game Development',
          'Mobile App Basics',
          '3D Modeling Introduction'
        ],
        structure: {
          lessons: '80 Lessons',
          activities: '80+ Activities | 80 Quizzes'
        },
        duration: {
          option1: '20 Months (1 Lesson/Week)',
          option2: '10 Months (2 Lessons/Week)'
        }
      },
      {
        id: 'polymath-advanced',
        title: 'Polymath Advanced',
        description: 'Comprehensive programming course for intermediate students.',
        learnItems: [
          'Advanced Python',
          'Full-Stack Web Development',
          'MySQL Database',
          'Advanced Game Development',
          'Mobile App Development',
          'UI/UX Design Basics'
        ],
        structure: {
          lessons: '120 Lessons',
          activities: '120+ Activities | 120 Quizzes'
        },
        duration: {
          option1: '30 Months (1 Lesson/Week)',
          option2: '15 Months (2 Lessons/Week)'
        }
      }
    ],
    '7-8': [
      {
        id: 'polymath',
        title: 'Polymath',
        description: 'This course is for teenagers to advance coding skills and understand complex concepts.',
        learnItems: [
          'C++ Programming',
          'Web Development Basics in HTML & CSS',
          'JavaScript Fundamentals',
          'MySQL Database',
          'Graphic Designing in Photoshop',
          'Game Development Basics'
        ],
        structure: {
          lessons: '80 Lessons',
          activities: '80+ Activities | 80 Quizzes'
        },
        duration: {
          option1: '10 Months (1 Lesson/Week)',
          option2: '15 Months (2 Lessons/Week)'
        }
      },
      {
        id: 'polymath-plus',
        title: 'Polymath+',
        description: 'A course for young minds to master coding and create websites and tools.',
        learnItems: [
          'All Polymath Course Modules',
          'AI Basics',
          'Advanced Web Development',
          'PHP Basics',
          'Advanced Game Development',
          'Advanced Graphic Designing Tools'
        ],
        structure: {
          lessons: '135 Lessons',
          activities: '135+ Activities | 135 Quizzes'
        },
        duration: {
          option1: '20 Months (1 Lesson/Week)',
          option2: '15 Months (2 Lessons/Week)'
        }
      }
    ],
    '9-12': [
      {
        id: 'polymath-plus-plus',
        title: 'Polymath++',
        description: 'The course for teenagers to master coding, design, and UI/UX for a successful future.',
        learnItems: [
          'All Polymath+ Modules',
          'Advanced AI',
          'JavaScript Object Model',
          'JSON',
          'Python Dictionary',
          'PHP Procedural Programming',
          'Database Management',
          'UI/UX Design'
        ],
        structure: {
          lessons: '225 Lessons',
          activities: '225+ Activities | 225 Quizzes'
        },
        duration: {
          option1: '30 Months (1 Lesson/Week)',
          option2: '15 Months (2 Lessons/Week)'
        }
      },
      {
        id: 'polymath-professional',
        title: 'Polymath Professional',
        description: 'Advanced professional development course for high school students.',
        learnItems: [
          'Advanced C++ & Data Structures',
          'Full-Stack Development',
          'Machine Learning Basics',
          'Cloud Computing',
          'DevOps Fundamentals',
          'Professional Portfolio Development'
        ],
        structure: {
          lessons: '300 Lessons',
          activities: '300+ Activities | 300 Quizzes'
        },
        duration: {
          option1: '40 Months (1 Lesson/Week)',
          option2: '20 Months (2 Lessons/Week)'
        }
      }
    ]
  };

  return (
    <section className="course-section">
      <div className="course-heading">
        <h1>
          <span className="purple-text">Choose A Course Or Follow A</span>
          <br />
          <span className="pink-text">Complete Roadmap</span>
        </h1>
      </div>

      <div className="grade-tabs">
        <button
          className={`grade-tab ${activeGrade === '1-3' ? 'active' : ''}`}
          onClick={() => handleGradeChange('1-3')}
        >
          Grade 1-3
        </button>
        <button
          className={`grade-tab ${activeGrade === '4-6' ? 'active' : ''}`}
          onClick={() => handleGradeChange('4-6')}
        >
          Grade 4-6
        </button>
        <button
          className={`grade-tab ${activeGrade === '7-8' ? 'active' : ''}`}
          onClick={() => handleGradeChange('7-8')}
        >
          Grade 7-8
        </button>
        <button
          className={`grade-tab ${activeGrade === '9-12' ? 'active' : ''}`}
          onClick={() => handleGradeChange('9-12')}
        >
          Grade 9-12
        </button>
      </div>

      <div className="course-cards">
        {courseData[activeGrade]?.map((course, index) => (
          <div key={course.id} className="course-card">
            <h2 className={`card-${course.id}`}>{course.title}</h2>
            <div className='course-card-content'>
              <p style={{ textAlign: 'justify' }}>{course.description}</p>

              <div className="learn-section">
                <h3 className={`card-${course.id}`}>What They'll Learn:</h3>
                <ul className="learn-list">
                  {course.learnItems.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="course-details">
                <h3 className={`card-${course.id}`}>Course Structure:</h3>
                <p>{course.structure.lessons}</p>
                <p>{course.structure.activities}</p>
              </div>

              <div className="course-details">
                <h3 className={`card-${course.id}`}>Duration:</h3>
                <p>{course.duration.option1}</p>
                <p>{course.duration.option2}</p>
              </div>

              <button className="request-btn"><Link to="/contact_us">Request Curriculum</Link></button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CourseSection;